import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const MultiplyIcon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref}>
    <>
      <rect width="24" height="24" fill="none" />
      <path d="m17.66 7.757-4.243 4.243 4.243 4.243-1.414 1.414-4.243-4.243-4.243 4.243-1.414-1.414 4.243-4.243-4.243-4.243 1.414-1.414 4.243 4.243 4.243-4.243z" />
    </>
  </SvgIcon>
));

export default MultiplyIcon;
